import AdprofitComponent from '@/view/adprofit'
const adProfit = {
  name: 'ad-profit',
  component: AdprofitComponent,
  meta: {
    title: '广告收益'
  }
}
export default adProfit
